import styled from 'styled-components'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'


const SkeletonStyle = styled.div`
width: 100%;
margin: 1rem auto;
.mayor {
    height: 90px;
}
.line {
    height: 20px;
    margin: 7px 0;
    width: 90% ;
}
.line:nth-child(3n) {
    width: 70% !important;
}
.line:nth-child(5n) {
    width: 80% !important;
}

`;


export const Loader =() => {
return (
        <SkeletonStyle>

                <Skeleton count={3} className='line'/>

                <Skeleton count={1} className='mayor' />
           
        </SkeletonStyle>
    )
}
    
    
